module.exports = __webpack_public_path__ + "static/img/floating-bg.a0e963e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/floating-bg.png
// module id = hZ6o
// module chunks = 2